import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  type ScheduleUploadProcessingFailedEventProps,
  type ScheduleUploadStartedEventProps,
} from '@/models/analytics/features/sessions';
import { trackSelfDescribingEvent } from '@snowplow/browser-tracker';
import {
  trackScheduleSyncedSpec,
  trackScheduleUploadCompletedSpec,
  trackScheduleUploadPromoClickedSpec,
  trackScheduleUploadPromoViewedSpec,
  trackScheduleUploadSessionsCreatedSpec,
  trackScheduleViewedSpec,
  type ScheduleSynced,
  type ScheduleUploadCompleted,
  type ScheduleUploadPromoClicked,
  type ScheduleUploadPromoViewed,
  type ScheduleUploadSessionsCreated,
  type ScheduleViewed,
} from '@snowtype/snowplow';
import type { SnowplowEventMap } from '../trackSnowplowEvent';

export const scheduleEvents: SnowplowEventMap = {
  [TrackingEventName.ScheduleViewed]: (props) =>
    trackScheduleViewedSpec(props as ScheduleViewed),
  [TrackingEventName.ScheduleSynced]: (props) =>
    trackScheduleSyncedSpec(props as ScheduleSynced),
  // schedule_upload_started / schedule_upload_processing_failed — hand-rolled
  // self-describing calls. The Iglu schemas are published at 1-0-0 (new) and
  // 1-0-2 (adds `error_code`), but the checked-in Snowtype output can't be
  // regenerated here (the console API credentials live in 1Password / CI).
  // TODO(snowtype): once snowtype/snowplow.ts is regenerated with console
  // creds, swap these to the generated Spec functions. The URIs below must
  // match data-structures/com.heidi/schedule_upload_*.yaml exactly.
  [TrackingEventName.ScheduleUploadStarted]: (props) =>
    trackSelfDescribingEvent({
      event: {
        schema: 'iglu:com.heidi/schedule_upload_started/jsonschema/1-0-0',
        data: props as ScheduleUploadStartedEventProps,
      },
    }),
  [TrackingEventName.ScheduleUploadProcessingFailed]: (props) =>
    trackSelfDescribingEvent({
      event: {
        schema: 'iglu:com.heidi/schedule_upload_processing_failed/jsonschema/1-0-2',
        data: props as ScheduleUploadProcessingFailedEventProps,
      },
    }),
  [TrackingEventName.ScheduleUploadCompleted]: (props) =>
    trackScheduleUploadCompletedSpec(props as ScheduleUploadCompleted),
  [TrackingEventName.ScheduleUploadPromoClicked]: (props) =>
    trackScheduleUploadPromoClickedSpec(props as ScheduleUploadPromoClicked),
  [TrackingEventName.ScheduleUploadPromoViewed]: (props) =>
    trackScheduleUploadPromoViewedSpec(props as ScheduleUploadPromoViewed),
  [TrackingEventName.ScheduleUploadSessionsCreated]: (props) =>
    trackScheduleUploadSessionsCreatedSpec(props as ScheduleUploadSessionsCreated),
};
